import { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { GrCart, GrSearch } from "react-icons/gr";
import axios from 'axios';
import { searchURL, mainImageURI } from './assets/constants/Urls/Url';

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [mobile, setMobile] = useState(null)

  const navigate = useNavigate();

  // Use refs for input and button
  const searchInputRef = useRef(null);

  // Sidebar toggle
  const toggleSidebar = () => setShowSidebar(!showSidebar);

  

  // Search bar input change handler
  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  
  useEffect(() => {
    const width = window.innerWidth;
    const isMobile = width && width < 576
    setMobile(isMobile)
  }, [])

  useEffect(() => {
    // Listen for browser back button
    const handlePopState = () => {
      if (showModal) setShowModal(false);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [showModal])


  // Handle search functionality
  const handleSearch = async (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      setIsLoading(true);
      try {
        const response = await axios.get(`${searchURL}?q=${searchQuery}`);
        setSearchResults(response.data || []);
        setShowModal(true);
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Handle Enter key and blur input
  const handleKeyDown = (event) => {
    event.stopPropagation(); // Prevent event bubbling
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default form submission
      if (searchInputRef.current) {
        searchInputRef.current.blur(); // Use the ref to blur the input
      }
      handleSearch(event); // Perform the search
    }
  };

  // Handle modal close
  const closeModal = (e) => {
    if (e.target.className.includes("search-modal")) setShowModal(false);  
  };

  
  // Handle card click navigation
  const handleCardClick = (id) => {
    navigate(`/product/${id}`);
    setShowModal(false);
  };

  return (
    <>
      {/* <nav className="navbar">
        <div className="navbar-content">
          
          <GrMenu className="menu-icon" size={24} onClick={toggleSidebar} />

          <div className="navbar-brand-section">
            
            <NavLink  to="/"><img className="nav-logo" src="/images/logo/TimeLib.jpg" alt="logo" /></NavLink>
          </div>

          
          

          <div className="navbar-actions">

          {!mobile?
          <div>
          <ul className="nav-list">
          <li>
              <NavLink to="/favorite" >
                <FaHeart size={20} /> Favorites
              </NavLink>
          </li>
          <li>
              <NavLink to="/" >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/profile" >
                <GrUser size={20} /> Account
              </NavLink>
            </li>
            
          </ul>
        </div>:''
          }
          
            <form onSubmit={handleSearch} className="search-bar">
              <input
                type="text"
                className="search-input"
                ref={searchInputRef} // Attach the ref
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown} // Add keydown event
              />
              <button type="submit" className="search-button">
                <GrSearch size={20} />
              </button>
            </form>
            <NavLink to="/cart" className="cart-icon">
              <GrCart size={24} color={"#00C135"} />
            </NavLink>
          </div>

          
        </div>
      </nav>

      
      <div className={`sidebar ${showSidebar ? 'open' : ''}`}>
        <button className="close-sidebar" onClick={toggleSidebar}>
          Close
        </button>
        <ul>
          <li><NavLink to="/profile" onClick={toggleSidebar}><GrUser size={20} /> Account</NavLink></li>
          <li><NavLink to="/favorite" onClick={toggleSidebar}><FaHeart size={20} /> Favorites</NavLink></li>
          <li><NavLink to="/"  onClick={toggleSidebar}>Home</NavLink></li>
        </ul>
      </div>

      
      
      {showModal && (
        <div className="search-modal " onClick={closeModal}>
          <div className="modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
            <h3>Search Results</h3>
            {searchResults.length > 0 ? (
              searchResults.map((result) => (
                <div key={result.id}
                  className="search-result-item"
                  onClick={() => handleCardClick(result.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <picture> 
                    <source srcSet={`${mainImageURI}${(String(result.id + "_" + 0)).replace(/\.(jpg|jpeg|png)$/, '.webp')}/${result.id}`} type="image/webp" />
                    <img 
                      src={`${mainImageURI}${String(result.id + "_" + 0)}/${result.id}`} 
                      className="card1-img-top " 
                      alt={result.name}
                      loading='lazy'
                    />
                  </picture>
                  <div style={{flexDirection:'column'}}>
                    <p style={{fontWeight:10}} >{result.name}</p>
                    <p style={{display:'block',color:'green',}}>{'$'+result.price}</p>
                  </div>
                  
                </div>
              ))
            ) : (
              <p>No results found.</p>
            )}
          </div>
        </div>
      )} */}
      

      <nav className="navbar">
        <div>
          <h1>
            TimeLib
          </h1>
        </div>

        <div>
          <div>
          <li>
            <NavLink to="/" className="nav-link">
              HOME
            </NavLink>
          </li>

          <li>
            <NavLink to="/product" className="nav-link">
              PRODUCTS
            </NavLink>
          </li>

          <li>
            <NavLink to="/about" className="nav-link">
              ABOUT US
            </NavLink>
          </li>
          </div>
          
        
          <div>
          <form>
            <input
              type='text'
              placeholder='Search...'
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown} // Add keydown event
            />
            <button type='submit' onClick={handleSearch}>
              <GrSearch size={20} />
            </button>
          </form>
          
          <NavLink to="/cart" className="nav-link" style={{margin: '0.5em'}}>
            <GrCart size={26} color={"gold"} />
          </NavLink>
          </div>
          
        </div>

      </nav>

      {showModal && (
        <div className="search-modal" onClick={closeModal}>
          
          <div className="modal-content">
          <div className="modal-header-static" style={{background:"var(--cardBackground)"}}>
              <h3 style={{margin:0}}>Search Results</h3>
              <button className="close-button" onClick={() => setShowModal(false)} aria-label="Close">×</button>
            </div>
            
            {isLoading ? (
              <p>Loading...</p>
            ) : searchResults.length > 0 ? (
              searchResults.map((result) => (
                <div key={result.id}
                  className="search-result-item"
                  onClick={() => handleCardClick(result.id)}
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '1em', padding: '0.5em 0', background:"var(--cardBackground)", color:"var(--textMain)" }}
                >
                  <picture style={{ flex: '0 0 60px', display: 'flex', alignItems: 'center' }}>
                    <source srcSet={`${mainImageURI}${(String(result.id + "_" + 0)).replace(/\.(jpg|jpeg|png)$/, '.webp')}/${result.id}`} type="image/webp" />
                    <img
                      src={`${mainImageURI}${String(result.id + "_" + 0)}/${result.id}`}
                      className="card1-img-top"
                      alt={result.name}
                      loading='lazy'
                      style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
                    />
                  </picture>
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <p style={{ fontWeight: 600, margin: 0, color: "var(--textMain)" }}>{result.name}</p>
                    <p style={{ color: 'green', margin: 0 }}>{'$' + result.price}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No results found.</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
  

  export default Navbar;
